import React from "react";
import { useDrop } from "react-dnd";
import styled from "styled-components";

import { Stem } from "@examspark/types";

import Mark from "../../common/Mark";

import TextGapToken from "./TextGapToken";
import { DndItem } from "./Token";

const Gap = styled.span`
  display: inline-flex;
  width: max-content;
  max-width: 100%;

  & {
    background-color: #fff;
    /* padding: 0 0.5rem; */
    border: dashed 2px #ccc;
    min-height: 2em;
    min-width: 5em;
    transition: border-color 0.2s;
    vertical-align: middle;
    position: relative;
    margin: 0 0.25rem;
  }
  & .remove {
    position: absolute;
    height: 1.7rem;
    width: 1.7rem;
    cursor: pointer;
  }
  & p {
    margin: 0;
  }
  & .remove:hover {
    background-color: #aaa;
  }
  &.is-drop-over {
    border: dashed 2px #006699;
  }
  & .markup {
    position: absolute;
    right: -1rem;
    top: -1rem;
  }
`;

export type GapDrop = {
  option: Stem.Option;
  drop: Stem.Drop;
};

type TextGapProps = {
  gapId: string;
  mark?: "correct" | "incorrect";
  dropped?: GapDrop[];
  onDrop: (gapId: string, item: DndItem) => void;
  onTokenRemove: (instanceId: string) => void;
};
const TextGap = (props: TextGapProps) => {
  const [{ isOver }, drop] = useDrop<DndItem, void, { isOver: boolean }>({
    accept: "token",
    drop: (item) => {
      props.onDrop(props.gapId, item);
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  // todo: move these styles to a (closer) styled component
  const classes = ["gap"];
  if (isOver) {
    classes.push("is-drop-over");
  }
  if (props.dropped) {
    classes.push("is-filled");
  }

  return (
    <Gap ref={drop} className={classes.join(" ")}>
      {props.mark && <Mark type={props.mark} />}

      {props.dropped?.map((token) => (
        <TextGapToken
          key={token.drop.instanceId}
          data={token.option}
          instanceId={token.drop.instanceId}
          gapId={token.drop.droppableId}
          onTokenRemove={() => props.onTokenRemove(token.drop.instanceId)}
        />
      ))}
    </Gap>
  );
};
export default TextGap;
